<template>
    <div class="select-subscription-plan">
        <template v-if="!isFrequency" >
            <div class="action-header">
                <div class="action-header__title">
                    Choose your plan. Protect your ads.
                </div>
            </div>
            <div class="select-container">
                <div class="select-column">
                    <div class="select-column-most-label" style="visibility: hidden;">Text</div>
                    <div class="select-column-title">Basic</div>
                    <div class="select-column-count">${{prices['basic']['annual_for_month']}}<span class="select-column-currency">USD</span></div>
                    <div class="select-column-billing-info">per month, billed annually or ${{prices['basic']['monthly']}} month-to-month</div>
                    <div class="btn btn-primary select-column-button" v-on:click="selectBasic">Activate now</div>
                    <div class="select-column-includes-title">Includes</div>
                    <div class="select-column-include">
                        <inline-svg
                            class="select-column-include-icon"
                            src="/images/google_a_logo_icon.svg" aria-label="My image">
                        </inline-svg>
                        <b>Unlimited Ads Accounts</b></div>
                    <div class="select-column-include">
                        <inline-svg
                            class="select-column-include-icon"
                            src="/images/click.svg" aria-label="My image">
                        </inline-svg>
                        Up to <b>5,000</b> Ad Clicks</div>
                    <div class="select-column-include">24/7 Monitoring</div>
                    <div class="select-column-include">Real-time Detection</div>
                    <div class="select-column-include">Automatic IP blocking</div>
                    <div class="select-column-include">IP Blocking Time Customization</div>
                    <div class="select-column-include">Cross-Campaign Blocking</div>
                    <div class="select-column-include">Insightful Dashboard</div>
                    <div class="select-column-include">Website Monitoring</div>
                </div>
                <div class="select-column">
                    <div class="select-column-most-label">Most Popular</div>
                    <div class="select-column-title">Standard</div>
                    <div class="select-column-count">
                        <span class="select-column-count">$55</span>
<!--                        <span class="select-column-count-old">$55</span>
                        <span class="select-column-count-new">$44</span>-->
                        <span class="select-column-currency">USD</span></div>
                    <div class="select-column-billing-info">
                        per month, billed annually or
                        <span>$69</span>
<!--                        <span class="select-column-billing-info-old">$69</span>
                        <span class="select-column-billing-info-new">$55</span>-->
                        month-to-month
                    </div>
                    <div class="btn btn-primary select-column-button" v-on:click="selectStandard">Activate now</div>
                    <div class="select-column-includes-title">Includes</div>
                    <div class="select-column-include">
                        <inline-svg
                            class="select-column-include-icon"
                            src="/images/google_a_logo_icon.svg" aria-label="My image">
                        </inline-svg>
                        <b>Unlimited Ads Accounts</b></div>
                    <div class="select-column-include">
                        <inline-svg
                            class="select-column-include-icon"
                            src="/images/click.svg" aria-label="My image">
                        </inline-svg>
                        Up to <b>10,000</b> Ad Clicks</div>
                    <div class="select-column-include">24/7 Monitoring</div>
                    <div class="select-column-include">Real-time Detection</div>
                    <div class="select-column-include">Automatic IP blocking</div>
                    <div class="select-column-include">IP Blocking Time Customization</div>
                    <div class="select-column-include">Cross-Campaign Blocking</div>
                    <div class="select-column-include">Insightful Dashboard</div>
                    <div class="select-column-include">Smart Exclusions List</div>
                    <div class="select-column-include">Rules Customization</div>
                    <div class="select-column-include">Priority Support</div>
                    <div class="select-column-include">Website Monitoring</div>
                </div>
                <div class="select-column">
                    <div class="select-column-most-label green">Most Value</div>
                    <div class="select-column-title">Professional</div>
                    <div class="select-column-count">
                        <span class="select-column-count">$119</span>
<!--                        <span class="select-column-count-old">$119</span>
                        <span class="select-column-count-new">$95</span>-->
                        <span class="select-column-currency">USD</span>
                    </div>
                    <div class="select-column-billing-info">
                        per month, billed annually or
                        <span>$149</span>
<!--                        <span class="select-column-billing-info-old">$149</span>
                        <span class="select-column-billing-info-new">$119</span>-->
                        month-to-month
                    </div>
                    <div class="btn btn-primary select-column-button" v-on:click="selectProfessional">Activate now</div>
                    <div class="select-column-includes-title">Includes</div>
                    <div class="select-column-include">
                        <inline-svg
                            class="select-column-include-icon"
                            src="/images/google_a_logo_icon.svg" aria-label="My image">
                        </inline-svg>
                        <b>Unlimited Ads Accounts</b></div>
                    <div class="select-column-include">
                        <inline-svg
                            class="select-column-include-icon"
                            src="/images/click.svg" aria-label="My image">
                        </inline-svg>
                        Up to <b>100,000</b> Ad Clicks</div>
                    <div class="select-column-include">24/7 Monitoring</div>
                    <div class="select-column-include">Real-time Detection</div>
                    <div class="select-column-include">Automatic IP blocking</div>
                    <div class="select-column-include">IP Blocking Time Customization</div>
                    <div class="select-column-include">Cross-Campaign Blocking</div>
                    <div class="select-column-include">Insightful Dashboard</div>
                    <div class="select-column-include">Smart Exclusions List</div>
                    <div class="select-column-include">Rules Customization</div>
                    <div class="select-column-include">Priority Support</div>
                    <div class="select-column-include">Personal account manager</div>
                    <div class="select-column-include">Website Monitoring</div>
                </div>
                <div class="select-column">
                    <div class="select-column-most-label" style="visibility: hidden;">Text</div>
                    <div class="select-column-title">Custom</div>
                    <div class="select-column-count">Contact us</div>
                    <div class="select-column-billing-info" style="visibility: hidden;">per month, billed annually or $-- month-to-month</div>

                    <a target="_blank" :href="'https://calendly.com/galia-s/ppc-shield-for-enterprise?name='+user_name+'&email='+user_email" class="btn btn-warning select-column-button">Schedule a call</a>

                    <div class="select-column-includes-title">Includes</div>
                    <div class="select-column-include">
                        Over 100,000 Ad Clicks and additional options to meet your corporate business needs
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="action-header">
                <div class="action-header__title">
                    Select billing frequency
                </div>
            </div>
            <div class="choose-frequency">
                <div class="choose-frequency-radio">
                    <div>
                        <input type="radio" id="monthly" name="price_time" :value="monthly_price.price_id" v-model="price_id">
                        <label for="monthly">
                            <div>Month-to-Month Subscription</div>
                            <div>${{monthly_price.cost}} billed monthly</div>
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="annual" name="price_time" :value="annual_price.price_id" v-model="price_id">
                        <label for="annual">
                            <div>Annual Subscription <span>SAVE 20%</span></div>
                            <div><span class="strike">${{monthly_price.cost.split(',')[0]*12+',00'}}</span> ${{annual_price.cost}} billed annually</div>
                        </label>
                    </div>
                </div>

                <form class="w-100" method="POST" action="/start-new-subscription">
                    <input required type="hidden" name="price_id" v-bind:value="price_id"/>
                    <input required type="hidden" name="plan_id" v-bind:value="plan_id"/>
                    <button class="btn btn-primary" type="submit">CONTINUE</button>
                </form>

                <div class="go-back"><span v-on:click="isFrequency = false">Go back</span></div>
            </div>
        </template>
    </div>
</template>
<script>
    export default {
        name: 'select-subscription-plan',
        props: ['release', 'user_name', 'user_email', 'raw_prices'],
        data: function () {
            return {
                plan_id: '',
                price_id: '',
                monthly_price: {price_id: '1', cost: 0},
                annual_price: {price_id: '2', cost: 0},
                isFrequency: false,
                prices: JSON.parse(this.raw_prices),
            }
        },
        methods: {
            getPlanInfo(plan_id){
                axios.get('/get-plan-info?plan='+plan_id)
                    .then(data => {
                        this.plan_id = plan_id;
                        this.monthly_price = data.data.monthly_price;
                        this.annual_price = data.data.annual_price;
                        this.price_id = data.data.monthly_price.price_id;
                        this.isFrequency = true;
                    });
            },
            selectBasic(){
                if(this.release === 'production') this.getPlanInfo('prod_IX9Dq2mkTkVMJt');
                else this.getPlanInfo('prod_IZ3QeJMZncagRc');
            },
            selectStandard(){
                if(this.release === 'production') this.getPlanInfo('prod_IXAcu57fcVsXGD');
                else this.getPlanInfo('prod_IZ3tTq6HQezz2d');
            },
            selectProfessional(){
                if(this.release === 'production') this.getPlanInfo('prod_IXAdp5ytUf571U');
                else this.getPlanInfo('prod_J5XEVxCCeJFuh6');
            },
        },
        mounted() {

        }
    }
</script>
